import { Content, Horizontal, StretchSpacer, Vertical } from "gls/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { style, stylesheet } from "typestyle";
import { Colours, fontFamily, Sizes } from "../../styles";
import { Form } from "../Form/Form";
import { FormTextInput } from "../Form/FormTextInput";
import { FormState, FormValidator } from "../Form/types";
import { isMandatory } from "../Form/validators/isMandatoryValidator";

export interface ForgotPasswordConfirmProps {
  onSubmit: (confirmationCode: string, newPassword: string) => void;
  onBackToLogin?: () => void;
}

const passwordsMatch: FormValidator = {
  error: "Passwords do not match",
  isValid: (value, formState) => value === formState.newPassword?.value,
};

export const ForgotPasswordConfirm: React.FC<ForgotPasswordConfirmProps> = ({
  onSubmit,
  onBackToLogin,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ confirmationCode, newPassword }: FormState) => {
    onSubmit(confirmationCode.value, newPassword.value);
  };

  return (
    <Vertical
      width={300}
      spacing={15}
      className={style({ fontFamily: fontFamily })}
      data-testid="login-forgot-confirm"
    >
      <Form
        title={t("Set a new password")}
        onSubmit={onSubmitHandler}
        submitButtonText={t("Set password")}
      >
        <FormTextInput
          name="confirmationCode"
          label={t("Verification code")}
          validators={[isMandatory]}
        />

        <FormTextInput
          name="newPassword"
          password
          label={t("New password")}
          validators={[isMandatory]}
        />

        <FormTextInput
          name="confirmPassword"
          password
          label={t("Confirm new password")}
          validators={[isMandatory, passwordsMatch]}
        />
      </Form>
      {onBackToLogin && (
        <Horizontal>
          <StretchSpacer />
          <Content
            horizontalAlign="right"
            className={classNames.backLabel}
            onClick={() => onBackToLogin?.()}
          >
            {t("Back to login")}
          </Content>
        </Horizontal>
      )}
    </Vertical>
  );
};

const classNames = stylesheet({
  backLabel: {
    color: Colours.textDark,
    cursor: "pointer",
    fontSize: Sizes.fontSize1,
    $nest: {
      "&:hover": {
        color: Colours.textLight,
      },
    },
  },
});
